import { getCard, getDeckCode } from '../../shared/index.js';
export function initTrick() {
    return { cards: [] };
}
export function getPlayerHand(hands, playerId) {
    const hand = hands.find((hand) => hand.playerId === playerId);
    if (!hand) {
        throw new Error('could not find players hand');
    }
    return hand;
}
export function getLedSuit(param, trick) {
    const deckCode = getDeckCode(param);
    if (!trick?.cards.length) {
        return undefined;
    }
    const card = getCard(deckCode, trick.cards[0].card);
    return card.suit;
}
//# sourceMappingURL=trick.js.map